import React from "react";
import { useApp } from "../../../../contexts/AppContext";
import {
  GenericDoubleDonutChart,
  DoubleDonutCategoryItem,
} from "../ChartTypes/GenericDoubleDonutChart";
import { EMPTY_PIPELINE_BY_LEAD_SOURCES_MESSAGE } from "../../../../utils/consts";

export interface PipelineByLeadSourcesChartProps {
  title?: string;
  loading?: boolean;
  categories: DoubleDonutCategoryItem[];
}

export const PipelineByLeadSourcesChart: React.FC<
  PipelineByLeadSourcesChartProps
> = ({ title = "Pipeline by Lead Sources", loading = false, categories }) => {
  const { drawerOpen } = useApp();

  return (
    <GenericDoubleDonutChart
      title={title}
      titleAlign="left"
      categories={categories}
      loading={loading}
      height={400}
      minHeight={400}
      emptyMessage={EMPTY_PIPELINE_BY_LEAD_SOURCES_MESSAGE}
      resizeTrigger={drawerOpen}
      legendPosition="right"
      tooltipValueFormatter={(value, percent) =>
        `${value.toLocaleString("en-US")} (${percent.toFixed(2)}%)`
      }
    />
  );
};
